var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-property"
  }, [_vm.response.product.propertyGroup.length ? [_vm._l(_vm.response.product.propertyGroup, function (item, index) {
    return _c('Specifications', {
      key: index,
      attrs: {
        "title": item.title,
        "properties": item.list
      }
    });
  }), _vm._v(" "), _c('span', {
    staticClass: "product-property__note"
  }, [_vm._v("Характеристики, комплект поставки и внешний вид данного товара могут отличаться от указанных или могут быть изменены производителем\n      без уведомления.")]), _vm._v(" "), _c('FoundError', {
    on: {
      "found": function ($event) {
        return _vm.enableFoundError(_vm.response.product.id);
      }
    }
  })] : _c('StatusBlock', {
    attrs: {
      "size": "m",
      "type": "empty",
      "title": "Для товара нет характеристик"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }